import { DocumentNode } from 'graphql';
import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { IProductSchemaPartial } from '../../type/product';
import { ITranslationSubTypeInput } from '../../type/_inputTypes/translation';

export interface IUpdateProductInformationMutationFields {
  _id: string;
  status: boolean;
  featured: boolean;
  enableDropshipping: boolean;

  importId: string;
  ordering: string;
  condition: string;
  categoryOrdering: Record<string, string>;

  name: ITranslationSubTypeInput[];
  introduction: ITranslationSubTypeInput[];
  unit: ITranslationSubTypeInput[];
  hsCode?: string;

  origin: string;
  referenceUrl: string;

  seoKeywords?: string[];

  classifications: string[];
  brands: string[];
  tags: string[];

  hideDisplayPrice: boolean;
  currency: string;
  costPrice: number
  basePrice: number
  finalPrice: number
  regularPrice: number
  overridePrice: number
}


export interface IUpdateProductInformationMutationResponseFields {
  updatedProduct: IProductSchemaPartial;
}


export function updateProductInformationMutation(fragment: string): DocumentNode {
  return gql`
        mutation updateProductInformation (
        $_id: String!,
$status: Boolean!,
$featured: Boolean!,
$enableDropshipping: Boolean!,
$importId: String,
$ordering: String,
$condition: String!,
$categoryOrdering: JSON,
$name: [TranslationSubTypeInput]!,
$introduction: [TranslationSubTypeInput]!,
$unit: [TranslationSubTypeInput]!,
$hsCode: String,
$origin: String,
$referenceUrl: String,
$seoKeywords: [String],
$classifications: [String]!,
$brands: [String]!,
$tags: [String]!,
$hideDisplayPrice: Boolean!,
$currency: String,
$costPrice: Float,
$basePrice: Float,
$finalPrice: Float,
$regularPrice: Float,
$overridePrice: Float
        ) {
        updateProductInformation (
        _id: $_id,
status: $status,
featured: $featured,
enableDropshipping: $enableDropshipping,
importId: $importId,
ordering: $ordering,
condition: $condition,
categoryOrdering: $categoryOrdering,
name: $name,
introduction: $introduction,
unit: $unit,
hsCode: $hsCode,
origin: $origin,
referenceUrl: $referenceUrl,
seoKeywords: $seoKeywords,
classifications: $classifications,
brands: $brands,
tags: $tags,
hideDisplayPrice: $hideDisplayPrice,
currency: $currency,
costPrice: $costPrice,
basePrice: $basePrice,
finalPrice: $finalPrice,
regularPrice: $regularPrice,
overridePrice: $overridePrice
        ) {
        ...fragment
        }
        }
        fragment fragment on UpdateProductInformationMutationResponse {
        code
        success
        message
        ${fragment}
        }
    `;
}

export function useUpdateProductInformationMutation<TData extends Partial<IUpdateProductInformationMutationResponseFields>>(
  fragment: string, options?: MutationHookOptions<{ updateProductInformation: TData },
        IUpdateProductInformationMutationFields>,
) {
  return useMutation<{ updateProductInformation: TData },
      IUpdateProductInformationMutationFields>(
        updateProductInformationMutation(fragment), options,
      );
}
